module.exports = __webpack_public_path__ + "static/media/14UNEP23.0c26c7cb.jpg";